import gql from 'graphql-tag'

export default gql`query ycmdRecordingUrlGet($recording_id: ID, $invoice_id: ID, $params: [NameValueInput]) {
    ycmdRecordingUrlGet(recording_id: $recording_id, invoice_id: $invoice_id, params: $params)
}`
